import Vue from 'vue'
import axios from 'axios'
import service from '../service'
import utils from '../utils/utils'
const prefix = process.env.VUE_APP_PREFIX
const instance = axios.create({
  timeout: 10000
});

window.isRefreshing = false;
let refreshSubscribers = []

instance.defaults.baseURL = process.env.VUE_APP_STATISTICS;

instance.interceptors.request.use(function (config) {
  let url = config.url;
  // console.log('url',config.data)
  let authToken = localStorage.getItem(prefix+'burryToken');

  if (!authToken && url && url.indexOf("getToken") === -1) {
    let sessionId = localStorage.getItem('burrySessionId')
    // localStorage.setItem('burrySessionId',sessionId)
    if (!window.isRefreshing) {
      window.isRefreshing = true;
      // service.getStatisToken({
      //   sessionId: sessionId,
      //   loginUser: "h5_visitor",
      //   password: "xZsVty8RDW"
      // }).then(res=>{
      //   if(res.status === "200"){
      //       window.isRefreshing = false;
      //       // config.headers.Authorization = "Bearer " + res.h5_token;

      //       localStorage.setItem(prefix+"burryToken", res.h5_token)

      //       onRrefreshed(res.h5_token)
      //   }else{
      //       localStorage.removeItem(prefix+"burryToken")
      //       window.isRefreshing = false;
      //   }
      // })
    }

    let retry = new Promise((resolve, reject) => {
      subscribeTokenRefresh((token) => {
        if(token){
          config.headers.Authorization = 'Bearer ' + token
        }else{
          config.headers.Authorization = ""
        }
          
          resolve(config)
      })
    })
    return retry
  }else if(url.indexOf("getToken") !== -1){

  }else{
    if(url.indexOf("access_token")< 0){
      config.url = config.url + "?access_token="+ authToken;
    }
    
  }
  

  return config
})
instance.interceptors.response.use((res) => {
  return Promise.resolve(res.data)
}, (error) => {
  localStorage.removeItem(prefix+"burryToken")
  let errdata = error.response ?error.response.data : error;
  return Promise.reject(errdata);
})

function generateGuid(){
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  const PRE = 's_';
  return PRE + s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

function onRrefreshed (token) {
  refreshSubscribers.map(cb => cb(token))
}

function subscribeTokenRefresh (cb) {
  refreshSubscribers.push(cb)
}


export default instance